function getRecentlyViewedProducts() {
  let viewedProducts = [];
  const viewedProductsString = localStorage.getItem('recently_viewed_products');
  if (viewedProductsString) {
    viewedProducts = JSON.parse(viewedProductsString);
  }
  return viewedProducts;
}

function addRecentlyViewedProduct() {
  const productHandle = document.querySelector('[data-product-handle]').dataset.productHandle;
  let viewedProducts = getRecentlyViewedProducts();
  const index = viewedProducts.indexOf(productHandle);
  if (index > -1) {
    viewedProducts.splice(index, 1);
  }
  viewedProducts.unshift(productHandle);
  const arrLength = viewedProducts.length;
  const maxNumber = 12;
  if (arrLength > maxNumber) {
    viewedProducts.splice(-1, arrLength - maxNumber);
  }
  localStorage.setItem('recently_viewed_products', JSON.stringify(viewedProducts));
}

function setStickyHeight() {
  if (window.matchMedia('(max-width: 960px)').matches) {
    const stickyMobileDiv = document.querySelector('.sticky-form--mobile');

    document.documentElement.style.setProperty('--mobile-form-height', `${stickyMobileDiv.offsetHeight}px`);
  }
}
setStickyHeight();

document.addEventListener('DOMContentLoaded', addRecentlyViewedProduct);
document.addEventListener('DOMContentLoaded', setStickyHeight);
window.addEventListener('resize', setStickyHeight);

class AddToCartForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.submitForm.bind(this));
    this.formSubmit = this.form.querySelector('button');
    this.addToCartPanel = document.querySelector('[data-panel="add-to-cart"]');
  }

  submitForm(event) {
    event.preventDefault();
    this.formSubmit.textContent = window.translations.adding;
    this.classList.add('adding');
    const formData = new FormData(this.form);

    const config = {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: `application/json` },
      body: formData,
    };

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        this.classList.add('added');

        this.formSubmit.textContent = window.translations.added;
        this.addToCartPanel.openCart();
        setTimeout(() => {
          this.classList.remove('added');
          this.classList.remove('adding');
          this.formSubmit.textContent = window.translations.add_to_cart;
        }, 2000);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {});
  }
}
customElements.define('add-to-cart-form', AddToCartForm);
